/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <div class="itemBodyMain">
      <div class="card">
        <div class="cardList">
          <div class="cardItem" @click="item.selected=!item.selected" v-for="(item,index) in typeList" :key="index">
            <div class="select" :class="{selected:item.selected}"></div>
            <div class="dot" :style="'background:'+item.color"></div>
            <div class="name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";

export default {
  name: "index",
  components: {titleInfo},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: '',
      typeList: [{
        title: '开箱',
        color: 'rgba(52, 220, 252, 1)',
        selected: false
      }, {
        title: '关箱',
        color: 'rgba(4, 149, 251, 1)',
        selected: false
      }, {
        title: '开箱异常',
        color: 'rgba(204, 47, 10, 1)',
        selected: false
      }, {
        title: '其他异常',
        color: 'rgba(255, 198, 62, 1)',
        selected: false
      }, {
        title: '离线',
        color: 'rgba(0, 26, 140, 1)',
        selected: false
      },]
    }
  },
  watch: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 0px);
  }
}

.card {
  background: url("../../../assets/home/cardBg.png");
  width: 160px;
  height: 213px;
  position: absolute;
  right: 11px;
  bottom: 11px;
  pointer-events: initial;
  background-size: 100% 100%;


  .cardList {
    padding-top: 20px;

    .cardItem {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      margin-bottom: 20px;

      .select {
        margin-left: 24px;
        background: url("../../../assets/home/icon_select.png");
        background-size: 100% 100%;
        width: 16px;
        height: 16px;
      }

      .selected {
        margin-left: 24px;
        background: url("../../../assets/home/icon_selected.png");
        background-size: 100% 100%;
        width: 16px;
        height: 16px;
      }

      .dot {
        width: 7px;
        height: 7px;
        background: #FFC63E;
        border-radius: 50%;
        margin-left: 10px;
        margin-right: 8px;
      }

      .name {
        font-size: 14px;
        font-family: PingFang;
        font-weight: 500;
        color: #34DCFC;
      }
    }
  }
}
</style>
